import { render, staticRenderFns } from "./Prieskum.vue?vue&type=template&id=068207b8"
import script from "./Prieskum.vue?vue&type=script&lang=js"
export * from "./Prieskum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports